<template>
  <div
    ref="intro"
    class="intro">
    <div class="intro-container">
      <img
        v-if="site.site_logo_white?.url"
        ref="introImage"
        :src="site.site_logo_white?.url || ''"
        alt="site-logo"
        class="branding-green" />
    </div>
  </div>
</template>

<script setup>
import useIntroShown from '@/composables/useIntroShown.js'
import { ref, onMounted } from 'vue'
import { useStore } from '@/stores/main'
import useSmoothScroll from '@/composables/useSmoothScroll.js'
import gsap from 'gsap/all'

const store = useStore()
const introImage = ref(null)
const { locoScroll } = useSmoothScroll()
const site = ref(store.acfOptions())

const { setIntroComplete } = useIntroShown()

onMounted(() => {
  locoScroll.stop()
  document.documentElement.classList.add('no-overflow')

  gsap.fromTo(
    introImage.value,
    {
      y: '40vh',
      width: '50vw',
    },
    {
      y: 0,
      width: '170px',
      delay: 2,
      duration: 1.5,
      ease: 'power4.out',
    }
  )

  setTimeout(() => {
    locoScroll.start()
    setIntroComplete()
    document.documentElement.classList.remove('no-overflow')
  }, 2500)
})
</script>

<style lang="scss">
.intro {
  @apply fixed left-0 top-0 z-[51] h-full w-full bg-capstan-dark;
  .intro-container {
    @apply relative left-0 flex h-[100vh] w-[100vw] items-start justify-start bg-cover bg-no-repeat px-5 py-[29px] lg:py-[38px];
    .branding-green {
      @apply origin-top-left;
    }
  }
}
</style>
